"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetWebClientId = exports.useCreateOrUpdateWebClientId = exports.useWebClientId = void 0;
/* eslint-disable sonarjs/no-identical-functions */ // TODO - Remove this ESLINT DISABLE
const js_cookie_1 = __importDefault(require("js-cookie"));
const react_1 = require("react");
const sc_cookies_1 = require("../lib/sc-cookies");
// THIS FUNCTION IS DEPRECATED. PLEASE USE useCreateOrUpdateWebClientId or useGetWebClientId functions instead
const useWebClientId = (params) => {
    const [webClientId, setWebClientId] = (0, react_1.useState)();
    const { isGdpr = true } = params ?? {};
    (0, react_1.useEffect)(() => {
        const cookie = (0, sc_cookies_1.getUpdatedWebClientIdCookie)(document.cookie, document.location.host, isGdpr);
        if (!cookie) {
            // user has opted out of essential session cookies
            return;
        }
        const { key, value, options } = cookie;
        // web_client_id is an essential cookie, so can be stored without user consent
        js_cookie_1.default.set(key, value, options);
        setWebClientId(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps --- we only want the effect to run once, after mount
    }, []);
    return webClientId;
};
exports.useWebClientId = useWebClientId;
// Creates a webclientID or updates the existing one
const useCreateOrUpdateWebClientId = (params) => {
    const [webClientId, setWebClientId] = (0, react_1.useState)();
    const { isGdpr = true } = params ?? {};
    (0, react_1.useEffect)(() => {
        const cookie = (0, sc_cookies_1.getUpdatedWebClientIdCookie)(document.cookie, document.location.host, isGdpr);
        if (!cookie) {
            // user has opted out of essential session cookies
            return;
        }
        const { key, value, options } = cookie;
        // web_client_id is an essential cookie, so can be stored without user consent
        js_cookie_1.default.set(key, value, options);
        setWebClientId(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps --- we only want the effect to run once, after mount
    }, []);
    return webClientId;
};
exports.useCreateOrUpdateWebClientId = useCreateOrUpdateWebClientId;
// Gets the current webclient ID or returns undefined if not present
const useGetWebClientId = () => {
    /* istanbul ignore next : Remove once test code is added */
    if (typeof window === "undefined") {
        return undefined;
    }
    return (0, sc_cookies_1.getWebClientId)(document.cookie);
};
exports.useGetWebClientId = useGetWebClientId;
//# sourceMappingURL=web-client-id.js.map